export class Alias {
    constructor(
        readonly id: number,
        readonly alert_alias: string,
        readonly email: string,
        readonly phone_number: string
    ) { }
}
